// export const getReferenceAccountData = (bankAccounts) => bankAccounts
//   .filter((account) => account.account_type === 'checkacc')
//   .map((item) => ({
//     // id: Number.parseInt(item.id, 10),
//     id: String(item.id),
//     account_no: item.account_no,
//     BIC: item.BIC_data.BIC,
//     currency: item.currency,
//     currency_detail: item.currency_detail,
//     org_name: `${item.BIC_data.org_name.substring(0, 10)}...`,
//   }));


    export const getReferenceAccountData = (bankAccounts) => {
    // Add safety check for bankAccounts
    if (!Array.isArray(bankAccounts)) {
      return [];
    }
  
    return bankAccounts
      .filter((account) => account?.account_type === 'checkacc')
      .map((item) => ({
        id: String(item.id),
        account_no: item.account_no || '',
        BIC: item.BIC_data?.BIC || '',
        currency: item.currency || '',
        currency_detail: item.currency_detail || {},
        // Add null/undefined checks for org_name
        org_name: item.BIC_data?.org_name 
          ? `${item.BIC_data.org_name.substring(0, 10)}...` 
          : 'N/A',
      }));
  };

// export const getReferenceAccountData = (bankAccounts) => {
//   // Add safety checks to prevent errors
//   if (!Array.isArray(bankAccounts)) {
//     return [];
//   }

//   return bankAccounts
//     .filter((account) => account?.account_type === 'checkacc')
//     .map((item) => ({
//       id: Number.parseInt(item.id, 10),
//       account_no: item.account_no || '',
//       BIC: item.BIC_data?.BIC || '',
//       org_name: item.BIC_data?.org_name 
//         ? `${item.BIC_data.org_name.substring(0, 10)}...`
//         : 'Unknown Bank',
//     }))
//     .filter(item => item.id && item.account_no); // Filter out invalid entries
// };

